import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import Button from "../../button/Button";
import styles from "./ChangePasswordModal.module.scss";
import { usePasswordUpdateRequestMutation } from "../../../store/services/auth-api";
import { useAppSelector } from "../../../store/hooks";
import { trackEvent } from "../../../utils/analytics";
import { EVENT_NAMES } from "../../../types/event-names";

interface ChangePasswordModalProps {
  setIsModalPasswordVisible: (arg: boolean) => void;
  setIsModalSendLinkVisible: (arg: boolean) => void;
}

const ChangePasswordModal: React.FC<ChangePasswordModalProps> = ({
  setIsModalPasswordVisible,
  setIsModalSendLinkVisible,
}) => {
  const authState = useAppSelector((state) => state.auth);
  const { t } = useTranslation();
  const [passwordUpdateRequest] = usePasswordUpdateRequestMutation();
  const [isLoading, setIsLoading] = useState(false);

  const onSendMagicClickHandler = async () => {
    try {
      setIsLoading(true);
      trackEvent(EVENT_NAMES.CHANGE_PASSWORD_EMAIL_SENT);

      await passwordUpdateRequest({ email: authState.user?.email }).unwrap();
      setIsLoading(false);
      setIsModalPasswordVisible(false);
      setIsModalSendLinkVisible(true);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    trackEvent(EVENT_NAMES.CHANGE_PASSWORD_OPENED);
  }, []);

  return (
    <div className={styles.root}>
      <p className={styles.root_title}>{t("Create a New Password")}</p>
      <p className={styles.root_subtitle}>
        {t(
          "A confirmation code will be sent to your account email. Simply follow the instructions in the email to create a new password for your Fortect account."
        )}
      </p>
      <div className={styles.root_footer}>
        <Button
          onClick={() => setIsModalPasswordVisible(false)}
          text={t("Close")}
          type="default"
          classNames={styles.root_footer_close}
        />
        <Button
          onClick={onSendMagicClickHandler}
          text={t("Get Confirmation Code")}
          classNames={styles.root_footer_generate}
          isLoader={isLoading}
        />
      </div>
    </div>
  );
};

export default ChangePasswordModal;
